import { render, staticRenderFns } from "./incomePlanDetail.vue?vue&type=template&id=1902085f&scoped=true"
import script from "./incomePlanDetail.vue?vue&type=script&lang=js"
export * from "./incomePlanDetail.vue?vue&type=script&lang=js"
import style0 from "./incomePlanDetail.vue?vue&type=style&index=0&id=1902085f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1902085f",
  null
  
)

export default component.exports